import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography, Container, Box, Divider } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import {
  clearEmailPasswordLoginError,
  loginWithEmailAndPassword,
  loginWithGoogle,
  signupWithEmailAndPassword,
  usersSliceSelector,
} from "../../redux/features/usersSlice";
import LoadingOverlay from "../LoadingOverlay";
import { useOutletContext } from "react-router-dom";
import LoginForm from "./LoginForm";
import CreateAccountForm from "./CreateAccountForm";
import logger from "../../utils/logger";

const LandingPage = () => {
  const { authState } = useOutletContext();
  const usersState = useSelector((state) => usersSliceSelector(state));
  const dispatch = useDispatch();
  const { emailPasswordError } = usersState || {};
  const { message: emailPasswordErrorMessage } = emailPasswordError || {};

  logger.info("userState", usersState);

  const [isCreatingAccount, setIsCreatingAccount] = useState(false);

  const handleCreateAccountClick = (resetForm) => {
    setIsCreatingAccount(true);
    resetForm();
    dispatch(clearEmailPasswordLoginError());
  };

  const handleBackToLoginClick = (resetForm) => {
    setIsCreatingAccount(false);
    resetForm();
    dispatch(clearEmailPasswordLoginError());
  };

  const handleLoginWithGoogleClick = () => {
    dispatch(loginWithGoogle());
  };

  const handleLoginWithEmailPasswordClick = (email, password) => {
    dispatch(loginWithEmailAndPassword({ email, password }));
  };

  const handleSignupWithEmailPasswordClick = (email, password) => {
    dispatch(signupWithEmailAndPassword({ email, password }));
  };

  return (
    <React.Fragment>
      <Box display={"flex"} justifyContent={"center"}>
        <Container maxWidth="xs">
          <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
            <Typography variant="h5" align="center" gutterBottom mb={4}>
              Welcome! Please login to continue.
            </Typography>
            <Typography variant="h4" gutterBottom>
              {isCreatingAccount ? "Create Account" : "Login"}
            </Typography>
            {isCreatingAccount ? (
              <CreateAccountForm
                onSubmit={handleSignupWithEmailPasswordClick}
                emailPasswordError={emailPasswordErrorMessage}
                onBackToLoginClick={handleBackToLoginClick}
              />
            ) : (
              <LoginForm
                onSubmit={handleLoginWithEmailPasswordClick}
                emailPasswordError={emailPasswordErrorMessage}
                onCreateAccountClick={handleCreateAccountClick}
              />
            )}
            <Box width="100%" mt={4}>
              <Divider>or</Divider>
              <Box mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  startIcon={<GoogleIcon />}
                  onClick={handleLoginWithGoogleClick}
                >
                  Login with Google
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
        <LoadingOverlay show={authState === "pending"} />
      </Box>
    </React.Fragment>
  );
};

export default LandingPage;
